<section class="content attendance-justification-type-page">
  <div class="content-block attendance-justification-type-page__content">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('attendanceJustificationTypesCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="attendance-justification-type-list-workspace">
      <app-master-table
        [title]="'attendanceJustificationTypesCatalog.title' | translate"
        [dataSource]="dataSource"
        [columnDefinitions]="columnDefinitions"
        [actions]="actions"
        [filters]="tableFilters"
        [isLoading]="isLoading"
        [enableRowClick]="false"
        [rowClickSelection]="true"
        [showContextMenu]="false"
        [tableMaxHeight]="'100%'"
        [searchValue]="searchValue"
        [exportFileName]="'attendance-justification-types'"
        (add)="handleAdd()"
        (details)="handleView($event)"
        (edit)="handleEdit($event)"
        (delete)="handleDelete($event)"
        (bulkDelete)="handleBulkDelete($event)"
        (searchChange)="onSearchChange($event)"
        (filtersChange)="onFiltersChange($event)">
      </app-master-table>
    </div>
  </div>
</section>
